export var EMBEDDED_CONFLUENCE_CONTENT_TYPE = /*#__PURE__*/function (EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
  EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
  EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
  EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
  return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});